<div class="page-content container">
    <div class="page-header">
      <h1 class="page-title text-primary-d2">
        Roles Partidos
        <small class="page-info text-secondary-d2">
          <i class="fa fa-angle-double-right text-80"></i>
          Lista
        </small>
      </h1>
    </div>



    <div class="row">
      <div class="col-12 col-sm-12 col-md-12">


        <div class="card ccard">
          <ul class="nav nav-tabs nav-tabs-simple nav-tabs-scroll border-b-1 brc-dark-l3 mx-0 mx-md-0 px-3 px-md-1 pt-2px" role="tablist">
            <li class="nav-item mr-1">
              <a class="nav-link active p-3 bgc-h-primary-l4 radius-0" id="home16-tab-btn" data-toggle="tab" href="#home16" role="tab" aria-controls="home16" aria-selected="true">
                <i class="fa fa-home text-success mr-3px"></i>
                Roles de Partidos
              </a>
            </li>

            <li class="nav-item mr-1">
              <a class="nav-link brc-purple-m1 d-style p-3 bgc-h-purple-l4 radius-0" id="profile16-tab-btn" data-toggle="tab" href="#profile16" role="tab" aria-controls="profile16" aria-selected="false">
                <i class="fa fa-user text-purple mr-3px"></i>

                <span class="d-n-active">
                    Agenda
                </span>
                <span class="d-active text-purple-d1">
                    Agenda
                </span>
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link p-3 bgc-h-primary-l4 radius-0" id="more16-tab-btn" data-toggle="tab" href="#more16" role="tab" aria-controls="more16" aria-selected="false">
                <i class="fa fa-plus text-blue mr-3px"></i>
                More
              </a>
            </li>
          </ul>

          <div class="card-body px-0 py-2">
            <div class="tab-content tab-sliding border-0 px-0">
              <div class="tab-pane show active text-95 px-25" id="home16" role="tabpanel" aria-labelledby="home16-tab-btn">
                <div class="bgc-primary-d1 text-white px-3 py-25">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <span class="text-90">Lista de</span>
                      Rol de Partidos
                    </div>
                    <div class="col-md-6 col-12">
                      <div class="columns columns-right btn-group float-right">
                        <button *ngIf="aplicacion.puede_crear" title="Nuevo" (click)="crearNuevoRolPartido()" class="btn btn-outline-default btn-smd bgc-white btn-h-light-primary btn-a-outline-primary py-1 bs-print" type="button">
                          <i class="fa fa-plus text-purple-d1"></i>
                        </button>
                        <div class="export btn-group">
                          <button class="btn btn-outline-default btn-smd bgc-white btn-h-light-primary btn-a-outline-primary py-1 dropdown-toggle" type="button" data-toggle="dropdown" aria-label="Opciones" title="Acciones" aria-expanded="true">
                            <i class="fa fa-wrench text-blue-d1"></i>
                            <span class="caret"></span>
                          </button>
                          <div class="dropdown-menu dropdown-menu-right enable-columns-bar" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-137px, 37px, 0px);" x-placement="bottom-end">
                            <div class="col-12 col-sm-12 mt-12 mt-sm-0 cards-container">
                              <div class="card bgc-primary brc-primary radius-0">
                                <div class="card-header">
                                <h5 class="card-title text-white font-light"><i class="fa fa-table mr-2px"></i> Acciones</h5>
                                </div>
          
                                <div class="card-body p-0 bg-white">
                                <table class="table table-striped table-hover mb-0">
                                  <tbody>
                                    <tr>
                                      <td class="text-dark-m2">
                                      Configuración Aplicación
                                      </td>
                                      <td class="text-dark-m2">
                                        <a (click)="abrirConfiguracionAplicacion()" href="javascript:void(0)" class="text-blue"><i class="fa fa-cog text-primary"></i></a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                </div>
                              </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bootstrap-table bootstrap4">
                  <div class="fixed-table-toolbar">
                    <div class="row">
                      <div class="col-12 col-md-7">
                        <div class="row">
                          <div class="col-12 col-md-12">
                            <app-paginator-header [paginator]="this"></app-paginator-header>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-md-12">
                            <div class="row">
                              <div class="col-md-2 col-sm-12" ><label>Campeonato </label></div>
                              <div class="col-md-3 col-sm-12">
                                <select [compareWith]="compararObjectos" class="form-control" required name="campeonato" [(ngModel)]="filter.campeonato">
                                    <option [ngValue]="campeonato" *ngFor="let campeonato of filter.campeonatos">{{campeonato.nombre}}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-5 p-0">
                        <div class="row">
                          <div class="col-12">
                            <button (click)="getSearch(text_search,null)" class="btn btn-xs btn-app btn-primary my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Buscar">
                              <i class="d-block h-4 fa fa fa-search text-150"></i>
                            </button>&nbsp;
                            <button (click)="abrirModalTablaPosiciones()" class="btn btn-xs btn-app btn-success my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Tabla Posiciones">
                              <i class="d-block h-4 fas fa-table text-150"></i>
                            </button>&nbsp;
                            <button (click)="abrirModalRolPartidosArbitro()" class="btn btn-xs btn-app btn-danger my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Rol Partidos Arbitro">
                              <i class="d-block h-4 fas fa-gavel text-150"></i>
                            </button>&nbsp;
                            <button (click)="abrirModalTablaGoleadores()" class="btn btn-xs btn-app btn-warning my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Goleadores">
                              <i class="d-block h-4 fas fa-futbol text-150"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <div class="fixed-table-container" style="padding-bottom: 0px;">
                    <div class="fixed-table-header" style="display: none;">
                      <table></table>
                    </div>
                    <div id="gallery" class="fixed-table-body">
                      <div class="fixed-table-loading table table-bordered table-hover" style="top: 46.6167px;">
                        <span class="loading-wrap">
                          <span class="animation-wrap">
                            <span class="animation-dot"></span>
                          </span>
                        </span>
                      </div>
                      <!-- tabla-tarjetas (styles.css): en el celular cada rol se ve como tarjeta -->
                      <table *ngIf="roles_partidos.length>0" class="table text-dark-m2 text-95 table-bordered table-hover table-striped table-responsive tabla-tarjetas tabla-roles" id="table">
                        <thead class="bgc-white text-grey text-uppercase text-80">
                          <tr>
                            <th>
                              <label class="py-0">
                                <input [(ngModel)]="allItemsSelected" (change)="seleccionarTodosItems(roles_partidos)" type="checkbox" class="align-bottom mb-n1 border-2 text-dark-m3" />
                              </label>
                            </th>
                            <th>N°</th>
                            <th class="center"><a href="javascript:void(0)">Código <span id="codigo" class="sort fa fa-sort icon-only"></span></a></th>
                            <th class="center"><a href="javascript:void(0)">Logo <span id="logo" class="sort fa fa-sort icon-only"></span></a></th>
                            <th class="center"><a href="javascript:void(0)">Campeonato <span id="campeonato" class="sort fa fa-sort icon-only"></span></a></th>
                            <th class="center"><a href="javascript:void(0)">Rol <span id="rol" class="sort fa fa-sort icon-only"></span></a></th>
                            <th class="center"><a href="javascript:void(0)">Actualizado <span id="actualizado" class="sort fa fa-sort icon-only"></span></a></th>
                            <th class="center"><a href="javascript:void(0)">Validez <span id="validez" class="sort fa fa-sort icon-only"></span></a></th>
                            <!-- en el celular este encabezado queda visible: planillas en blanco y fixture -->
                            <th class="th-celular" data-label="Planillas en blanco y fixture" style="text-align: center; width: 140px; " data-field="tools">
                              <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="generarPdfPlanillaPartidoBlanco('BALONCESTO')">
                                <i class="fas fa-basketball-ball"></i>
                              </a>
                              <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="generarPdfPlanillaPartidoBlanco('FÚTBOL DE SALÓN')">
                                <i class="fas fa-futbol"></i>
                              </a>
                              <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-warning btn-a-outline-warning btn-text-warning" href="javascript:void(0)" (click)="generarPdfPlanillaPartidoBlanco('VOLEIBOL')">
                                <i class="fas fa-volleyball-ball"></i>
                              </a>
                              <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="abrirRegistroRolFixturePartido()">
                                <i class="fa-hockey-puck fas"></i>
                              </a>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let rol_partido of roles_partidos; let i=index;">
                            <td class='text-center pr-0 pos-rel celda-check'>
                              <div class="position-tl h-100 ml-n1px border-l-4 brc-orange-m1 v-hover">
                                <!-- border shown on hover -->
                              </div>
                              <div class="position-tl h-100 ml-n1px border-l-4 brc-success-m1">
                                <!-- border shown when row is selected -->
                              </div>
            
                              <label>
                                <input [(ngModel)]="rol_partido.selected" (change)="agregarRolPartido(rol_partido)" type="checkbox" class="align-middle" />
                              </label>
                            </td>
                            <td class="celda-numero">
                              {{(i+1)+(this.itemsPerPage*(this.currentPage-1))}}
                            </td>
                            <td class="celda-dato" data-label="Código">
                                {{rol_partido.codigo}}
                            </td>
                            <td class="celda-logo">
                              <div class="imagen-campeonato-vista clearfix">
                                <a href="{{rest_server+rol_partido.campeonato.logo}}" title="{{rol_partido.campeonato.nombre}}" data-rel="colorbox">
                                    <img width="50" height="50" alt="sin imagen" src="{{rest_server+rol_partido.campeonato.logo}}" />
                                </a>
                            </div>
                            </td>
                            <td class="celda-campeonato">
                              {{rol_partido.campeonato.nombre}}
                          </td>
                            <td class="celda-titulo">
                              {{rol_partido.rol.nombre}}
                          </td>
                            <td class="celda-dato" data-label="Actualizado">
                              {{rol_partido.updatedAt | date:'dd/MM/yyyy - HH:mm'}}
                            </td>
                            <td class="celda-dato" data-label="Validez" *ngIf="rol_partido.activo"><span class="badge badge-sm badge-success">ACTIVO</span></td>
                            <td class="celda-dato" data-label="Validez" *ngIf="!rol_partido.activo"><span class="badge badge-sm badge-danger">ANULADO</span></td>
                            <td class="celda-acciones" style="text-align: center; width: 140px; ">
                              <div class="action-buttons">
                                <a *ngIf="aplicacion.puede_modificar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="modificarRolPartido(rol_partido)">
                                  <i class="fa fa-pencil-alt text-105"></i>
                                </a>
                                <!-- PDF de todo el rol en la lista clasica. Las imagenes para redes, los resultados y las
                                     planillas se generan desde el registro del rol, por cancha o con el fixture general -->
                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" title="PDF de todo el rol" (click)="generarPdfRolCompleto(rol_partido)">
                                  <i class="fas fa-file-pdf text-105"></i>
                                </a>
                                <a *ngIf="rol_partido.activo" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="cerrarCaja(rol_partido)">
                                  <i class="fa fa-lock text-105"></i>
                              </a>
                                <a *ngIf="aplicacion.puede_eliminar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacion(rol_partido)">
                                  <i class="fa fa-trash-alt text-105"></i>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="fixed-table-footer">
                      <table><thead><tr></tr></thead></table>
                    </div>
                  </div>
                  <div class="fixed-table-pagination">
                    <app-paginator-footer *ngIf="roles_partidos.length>0" class="pagination-detail" [paginator]="this"></app-paginator-footer>
                  </div>
                </div>
              </div>

              <div class="tab-pane text-95 px-25" id="profile16" role="tabpanel" aria-labelledby="profile16-tab-btn">
                <div class="col-12 col-sm-12 col-md-12" id='calendar-container'>
                  <div class="card acard">
                    <div class="card-body p-lg-4">
                      <full-calendar #calendar [options]="calendarOptions"></full-calendar>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-pane text-95 px-25" id="more16" role="tabpanel" aria-labelledby="more16-tab-btn">
                Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney's organic lomo retro fanny pack lo-fi farm-to-table readymade. Messenger bag gentrify pitchfork tattooed craft beer, iphone skateboard locavore carles etsy salvia banksy hoodie helvetica.
              </div>
            </div>
          </div>
        </div><!-- /.card -->
      </div>
    </div>
</div>

<ng-template #modal_registro_rol_partido let-modal>
    <div class="modal-header card-header">
        <div class="col-md-8 col-xs-8">
            <span class="text-blue text-125">Registro Rol Partido</span>
        </div>
        <div class="col-md-6 col-xs-6">
            <button *ngIf="aplicacion.puede_crear" (click)="guardarRolPartido()" class="btn btn-primary"  >
                <i class="fa fa-save text-110 mr-1"></i>
            </button>&nbsp;
            <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
                <i class="fa fa-times red2 text-110 mr-1"></i>
            </button>
        </div>
    </div>
    <div class="modal-body card-body">
        <div class="row">
          <div class="col-md-3">
              <label>Código</label>
              <input [disabled]="codigo_automatico" required type="text" id="codigo" name="codigo" [(ngModel)]="rol_partido.codigo" placeholder="Código" class="form-control" />
          </div>
          <div class="col-md-4">
              <label>Campeonato</label>
              <select [compareWith]="compararObjectos" class="form-control" required name="campeonato" [(ngModel)]="rol_partido.campeonato" (change)="obtenerEquiposCampeonato(rol_partido.campeonato,partido.categoria)">
                <option [ngValue]="campeonato" *ngFor="let campeonato of campeonatos">{{campeonato.nombre}}</option>
              </select>
          </div>
          <div class="col-md-3">
              <label>Rol</label>
              <select [compareWith]="compararObjectos" class="form-control" required name="rol" [(ngModel)]="rol_partido.rol">
                <option [ngValue]="rol" *ngFor="let rol of tipo_rol_partido.clases">{{rol.nombre}}</option>
              </select>
          </div>
          <div class="col-md-2">
            <span *ngIf="aplicacion.puede_crear" class="fa fa-edit point-edit blue" (click)="abrirConceptoEmpresa(global_variable.Dictionary.TIPO_ROLES_PARTIDOS,'obtenerRolesPartidosEmpresa')"></span>
        </div>
      </div>
      <!-- los partidos se cargan desde la matriz de cruces, en la cancha activa (dia y cancha) -->
      <div class="barra-turnos" *ngIf="aplicacion.puede_crear">
        <button type="button" (click)="alternarMatrizCruces()" class="btn btn-sm"
                [ngClass]="mostrar_matriz_cruces?'btn-warning':'btn-purple'" title="Matriz de cruces">
          <i class="fa fa-th mr-1"></i>{{mostrar_matriz_cruces?'Cerrar matriz':'Matriz de cruces'}}
        </button>
        <button *ngIf="mostrar_matriz_cruces && matriz_grupos.length>0" type="button" (click)="alternarPanelFixture()"
                [ngClass]="{'btn-outline-primary':!mostrar_panel_fixture,'btn-primary':mostrar_panel_fixture}"
                class="btn btn-sm" title="Planificar el rol de la semana con todas las categorías">
          <i class="fas fa-magic mr-1"></i>Planificar semana
        </button>
      </div>

      <ng-container *ngIf="mostrar_matriz_cruces">
        <hr>
        <div class="row">
          <div class="col-12">
            <div class="row mb-1">
              <div class="col-md-3 col-12">
                <span class="text-blue text-110">Matriz de Cruces</span>
              </div>
              <div class="col-md-5 col-12">
                <div class="form-inline text-90">
                  <label class="mr-1" *ngIf="matriz_grupo">Fase</label>
                  <select *ngIf="matriz_grupo" class="form-control form-control-sm mr-3" name="matriz_fase"
                          [ngModel]="matriz_filtro?.fase?.id" (ngModelChange)="cambiarFaseMatriz($event)">
                    <option [ngValue]="fase.id" *ngFor="let fase of tipo_fase.clases">{{fase.nombre}}</option>
                  </select>
                  <!-- pasa de fase todos los partidos ya registrados (por ejemplo, de ida y vuelta a solo ida) -->
                  <button *ngIf="matriz_grupo && aplicacion.puede_modificar" type="button" class="btn btn-sm btn-outline-warning mr-3"
                          (click)="abrirCambioFase()" title="Pasar de fase los partidos ya registrados del campeonato">
                    <i class="fas fa-exchange-alt mr-1"></i>Cambiar fase…
                  </button>
                  <label class="mr-1" title="Minutos que se suman al horario despues de marcar cada celda">Duración (min)</label>
                  <input type="number" min="0" step="5" name="matriz_duracion_partido" [(ngModel)]="matriz_duracion_partido" class="form-control form-control-sm" style="width:65px" />
                </div>
              </div>
              <div class="col-md-4 col-12">
                <div class="float-right text-90">
                  <span class="leyenda-matriz celda-vacia"></span> Libre
                  <span class="leyenda-matriz celda-jugado ml-2"></span> Jugado
                  <span class="leyenda-matriz celda-sin-guardar ml-2"></span> Sin guardar
                  <span class="leyenda-matriz matriz-equipo-baja ml-2"></span> Equipo retirado
                  <span class="leyenda-matriz celda-diagonal ml-2"></span> No aplica
                </div>
              </div>
            </div>
            <div class="row mb-1" *ngIf="matriz_grupos.length>0">
              <div class="col-12">
                <ul class="nav nav-tabs matriz-pestanas">
                  <li class="nav-item" *ngFor="let grupo of matriz_grupos">
                    <a class="nav-link" href="javascript:void(0)" (click)="seleccionarGrupoMatriz(grupo)"
                       [ngClass]="{'active':matriz_grupo==grupo}"
                       [title]="grupo.disciplina+' - '+grupo.categoria+' | '+grupo.equipos+' equipos, '+grupo.partidos+' partidos'">
                      {{grupo.disciplina}} <b>{{grupo.categoria}}</b>
                      <span class="matriz-badge ml-1">{{grupo.equipos}}</span>
                    </a>
                  </li>
                </ul>
              </div>
            <!-- cambio de fase en bloque: revisa cuantos partidos cambian y que cruces quedarian repetidos -->
            <div class="panel-cambio-fase mb-2" *ngIf="mostrar_cambio_fase">
              <div class="d-flex flex-wrap align-items-center cambio-fase-fila">
                <span class="font-bolder">Pasar los partidos de</span>
                <select [compareWith]="compararObjectos" class="form-control form-control-sm cambio-fase-select" name="cambio_fase_origen"
                        [(ngModel)]="cambio_fase.origen" (ngModelChange)="invalidarCambioFase()">
                  <option [ngValue]="fase" *ngFor="let fase of tipo_fase.clases">{{fase.nombre}}</option>
                </select>
                <span class="font-bolder">a</span>
                <select [compareWith]="compararObjectos" class="form-control form-control-sm cambio-fase-select" name="cambio_fase_destino"
                        [(ngModel)]="cambio_fase.destino" (ngModelChange)="invalidarCambioFase()">
                  <option [ngValue]="null" disabled>Fase de destino</option>
                  <option [ngValue]="fase" *ngFor="let fase of tipo_fase.clases">{{fase.nombre}}</option>
                </select>
              </div>
              <label class="d-block mt-2 mb-0">
                <input type="checkbox" class="align-middle mr-1" name="cambio_fase_todo" [(ngModel)]="cambio_fase.todo_campeonato" (ngModelChange)="invalidarCambioFase()" />
                Aplicar a todas las categorías y disciplinas del campeonato
                <span class="text-grey" *ngIf="!cambio_fase.todo_campeonato && matriz_filtro">(solo {{matriz_filtro.categoria.nombre}} · {{matriz_filtro.disciplina.nombre}})</span>
              </label>
              <div class="text-grey text-85 mt-1">Cambia los partidos de todos los roles del campeonato, ya guardados o no. Los resultados, ventas y cierres de caja no se tocan.</div>

              <div class="mt-2" *ngIf="cambio_fase.revisado">
                <div class="cambio-fase-resumen">
                  <b>{{cambio_fase.total}}</b> partido(s) pasan a <b>{{cambio_fase.destino?.nombre}}</b>
                  <span *ngIf="cambio_fase.grupos>1"> en {{cambio_fase.grupos}} categorías/disciplinas</span>.
                  <span *ngIf="cambio_fase.conflictos.length==0"> No quedan cruces repetidos.</span>
                </div>
                <div *ngIf="cambio_fase.conflictos.length>0" class="mt-2">
                  <div class="text-90 mb-1"><b>{{cambio_fase.conflictos.length}} cruce(s) quedarían repetidos.</b> Marca los partidos que quieres quitar (solo se pueden quitar los que no se jugaron ni tienen venta):</div>
                  <div class="cambio-fase-conflicto" *ngFor="let conflicto of cambio_fase.conflictos">
                    <div class="text-grey text-85">{{conflicto.categoria?.nombre}} · {{conflicto.disciplina?.nombre}}</div>
                    <label class="cambio-fase-partido" *ngFor="let partido_conflicto of conflicto.partidos" [ngClass]="{'no-quitable':!partido_conflicto.quitable}">
                      <input type="checkbox" class="align-middle mr-1" [disabled]="!partido_conflicto.quitable"
                             [(ngModel)]="partido_conflicto.quitar" [ngModelOptions]="{standalone:true}" />
                      Quitar
                      <b>{{partido_conflicto.equipo_1?.nombre}} vs {{partido_conflicto.equipo_2?.nombre}}</b>
                      <span class="text-grey">· {{partido_conflicto.fecha_hora | date:'dd/MM HH:mm'}} · rol {{partido_conflicto.rol_partido?.codigo}}</span>
                      <span class="badge badge-success ml-1" *ngIf="partido_conflicto.jugado">jugado {{partido_conflicto.marcador_equipo_1}}-{{partido_conflicto.marcador_equipo_2}}</span>
                      <span class="badge badge-warning ml-1" *ngIf="partido_conflicto.con_venta">con venta</span>
                      <span class="badge badge-info ml-1" *ngIf="partido_conflicto.sin_guardar">sin guardar</span>
                      <span class="badge badge-secondary ml-1" *ngIf="partido_conflicto.id_fase==cambio_fase.destino?.id">ya en {{cambio_fase.destino?.nombre}}</span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="mt-2 d-flex flex-wrap" style="gap:6px">
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="revisarCambioFase()">
                  <i class="fas fa-search mr-1"></i>Revisar
                </button>
                <button type="button" class="btn btn-sm btn-warning" (click)="aplicarCambioFase()"
                        [disabled]="!cambio_fase.revisado || cambio_fase.total==0" title="Primero revisa los partidos">
                  <i class="fas fa-exchange-alt mr-1"></i>Cambiar fase
                </button>
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="mostrar_cambio_fase=false">Cancelar</button>
              </div>
            </div>
            <div class="row mb-2" *ngIf="mostrar_panel_fixture && fixture">
              <div class="col-12 panel-fixture">
                <div class="row">
                  <div class="col-md-6 col-12">
                    <label class="text-90">Algoritmo de programación</label>
                    <select [compareWith]="compararObjectos" class="form-control form-control-sm"
                            name="fixture_algoritmo" [(ngModel)]="fixture.algoritmo"
                            (ngModelChange)="cambiarAlgoritmoFixture()">
                      <option [ngValue]="algoritmo" *ngFor="let algoritmo of algoritmos_fixture">{{algoritmo.nombre}}</option>
                    </select>
                  </div>
                  <!-- las prioridades del algoritmo elegido, en orden, para poder confirmarlas -->
                  <div class="col-md-6 col-12">
                    <label class="text-90">Prioridades, en orden</label>
                    <ol class="prioridades-fixture">
                      <li *ngFor="let prioridad of fixture.algoritmo.prioridades">{{prioridad}}</li>
                    </ol>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-3 col-12">
                    <label class="text-90">Semana desde</label>
                    <div class="input-group input-group-sm">
                      <input name="fixture_fecha" class="form-control form-control-sm" placeholder="dd/mm/yyyy"
                             [(ngModel)]="fixture.fecha_inicio_texto" ngbDatepicker #df="ngbDatepicker">
                      <div class="input-group-append">
                        <button class="btn btn-sm btn-outline-secondary calendar" (click)="df.toggle()" type="button"></button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-12">
                    <label class="text-90">Partidos por día y escenario</label>
                    <input type="number" min="1" name="fixture_por_dia" [(ngModel)]="fixture.partidos_por_dia_escenario"
                           class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-3 col-12">
                    <label class="text-90">Máx. partidos por equipo</label>
                    <input type="number" [min]="fixture.algoritmo.partidos_minimos" name="fixture_max_equipo"
                           [(ngModel)]="fixture.maximo_partidos_equipo_semana" class="form-control form-control-sm" />
                    <div class="text-grey text-85">Mínimo del algoritmo: {{fixture.algoritmo.partidos_minimos}}</div>
                  </div>
                  <div class="col-md-3 col-12">
                    <label class="text-90">Duración partido (min)</label>
                    <input type="number" min="5" step="5" name="fixture_duracion" [(ngModel)]="matriz_duracion_partido"
                           class="form-control form-control-sm" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-5 col-12">
                    <label class="text-90">Días a utilizar</label>
                    <div class="escenarios-fixture">
                      <label class="escenario-fixture" *ngFor="let dia of fixture.dias" [ngClass]="{'seleccionado':dia.usar}">
                        <input type="checkbox" [(ngModel)]="dia.usar" [name]="'dia_'+dia.dia" /> {{dia.nombre}}
                      </label>
                    </div>
                  </div>
                  <div class="col-md-7 col-12">
                    <label class="text-90">Escenarios (según su disponibilidad cargada)</label>
                    <div class="escenarios-fixture">
                      <label class="escenario-fixture" *ngFor="let escenario of fixture.escenarios"
                             [ngClass]="{'seleccionado':esEscenarioFixtureSeleccionado(escenario)}"
                             [title]="'Disponible: '+diasDisponiblesEscenario(escenario)">
                        <input type="checkbox" [checked]="esEscenarioFixtureSeleccionado(escenario)"
                               (change)="alternarEscenarioFixture(escenario)" />
                        {{escenario.nombre}}
                        <span class="dias-escenario">{{diasDisponiblesEscenario(escenario)}}</span>
                      </label>
                    </div>
                    <div *ngIf="fixture.escenarios.length==0" class="text-danger text-85 mt-1">
                      Ningún escenario tiene disponibilidad cargada. Cargala en Escenarios, con el botón del calendario.
                    </div>
                    <div *ngIf="fixture.escenarios_sin_disponibilidad>0" class="text-grey text-85 mt-1">
                      {{fixture.escenarios_sin_disponibilidad}} escenario(s) sin disponibilidad cargada quedan fuera.
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-8 col-12 text-grey text-85">
                    Se programa una semana con los cruces pendientes de <b>todas las categorías y disciplinas</b>
                    del campeonato. Ningún equipo juega dos veces el mismo día ni supera el máximo semanal.
                    El árbitro sale de los registrados para esa disciplina; la mesa se asigna después con "Mesa para toda la cancha".
                  </div>
                  <div class="col-md-4 col-12 text-right">
                    <button type="button" (click)="generarFixture()" class="btn btn-sm btn-success">
                      <i class="fas fa-magic mr-1"></i>Planificar semana
                    </button>
                    <button type="button" (click)="mostrar_panel_fixture=false" class="btn btn-sm btn-outline-secondary ml-1">
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div class="row mb-1" *ngIf="matriz_leyenda_fechas.length>0">
              <div class="col-12 text-90">
                <span class="text-grey mr-1">Pendientes por día:</span>
                <span class="mr-3 text-nowrap" *ngFor="let fecha_leyenda of matriz_leyenda_fechas">
                  <span class="leyenda-matriz" [style.background-color]="fecha_leyenda.color"></span>
                  <b>{{fecha_leyenda.abreviatura}}</b>
                  {{fecha_leyenda.dia_literal}} {{fecha_leyenda.fecha | date:'dd/MM/yyyy'}}
                  <span class="text-grey-m1">({{fecha_leyenda.partidos}})</span>
                </span>
              </div>
            </div>
            <!-- la cancha donde caen los cruces: al lado de la matriz en la computadora, debajo en el celular -->
            <div class="matriz-con-panel">
            <div class="matriz-columna">
            <div class="matriz-cruces-scroll" *ngIf="matriz_grupo">
              <table class="matriz-cruces" [ngClass]="matriz_densidad">
                <thead>
                  <tr>
                    <th class="matriz-indice-cabecera">N°</th>
                    <th class="matriz-equipo-cabecera">EQUIPOS</th>
                    <th class="matriz-cabecera" *ngFor="let equipo of matriz_equipos; let c=index;"
                        [ngClass]="{'matriz-equipo-baja':!equipo.activo}"
                        [title]="equipo.nombre+(equipo.activo?'':' (RETIRADO)')+' | '+matriz_resumen_equipos[c].total+' partidos ('+matriz_resumen_equipos[c].jugados+' jugados, '+matriz_resumen_equipos[c].pendientes+' pendientes)'+(equipo.observacion?(' | '+equipo.observacion):'')">
                      <div class="matriz-cabecera-texto">{{(c+1)}}. {{equipo.nombre}}</div>
                      <div class="matriz-cabecera-conteo">
                        <span class="matriz-badge">{{matriz_resumen_equipos[c].total}}</span>
                        <i *ngIf="equipo.observacion" class="fas fa-exclamation-circle marca-observacion"></i>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let fila of matriz_celdas; let f=index;">
                    <td class="matriz-indice">{{(f+1)}}</td>
                    <td class="matriz-equipo" [ngClass]="{'matriz-equipo-baja':!matriz_equipos[f].activo}"
                        [title]="matriz_equipos[f].nombre+(matriz_equipos[f].activo?'':' (RETIRADO)')">
                      <div class="matriz-equipo-linea">
                        <span class="matriz-badge"
                              [title]="matriz_resumen_equipos[f].total+' partidos ('+matriz_resumen_equipos[f].jugados+' jugados, '+matriz_resumen_equipos[f].pendientes+' pendientes)'">{{matriz_resumen_equipos[f].total}}</span>
                        <span class="matriz-equipo-nombre">{{matriz_equipos[f].nombre}}</span>
                      </div>
                      <div *ngIf="matriz_equipos[f].observacion" class="observacion-equipo">
                        <i class="fas fa-exclamation-circle mr-1"></i>{{matriz_equipos[f].observacion}}
                      </div>
                    </td>
                    <td *ngFor="let celda of fila"
                        (click)="clickCeldaMatriz(celda)"
                        [attr.draggable]="celda.movible?true:null"
                        (dragstart)="iniciarArrastreCelda($event,celda)"
                        (dragover)="permitirSoltarCelda($event,celda)"
                        (drop)="soltarCelda(celda)"
                        (dragend)="terminarArrastreCelda()"
                        [style.background-color]="celda.color_fecha"
                        [ngClass]="{'celda-movible':celda.movible,
                                    'celda-destino':celda_arrastrada && celda.estado=='vacia',
                                    'celda-diagonal':celda.estado=='diagonal',
                                    'celda-vacia':celda.estado=='vacia',
                                    'celda-programado':celda.estado=='programado',
                                    'celda-jugado':celda.estado=='jugado',
                                    'celda-espejo':celda.espejo,
                                    'celda-sin-guardar':celda.sin_guardar,
                                    'celda-equipo-baja':celda.estado=='vacia' && celda.equipo_baja}"
                        [title]="celda.estado=='diagonal'?'':(celda.equipo_fila.nombre+' vs '+celda.equipo_columna.nombre+(celda.partido?(' | '+(celda.partido.fecha_hora|date:'dd/MM/yyyy HH:mm')+(celda.partido.escenario?(' | '+celda.partido.escenario.nombre):'')+(celda.codigo_rol?(' | Rol '+celda.codigo_rol):'')):' | Click para programar'))">
                      <ng-container *ngIf="celda.partido">
                        <div class="celda-fecha" [style.color]="celda.color_texto_fecha">
                          <b *ngIf="celda.dia_abreviado">{{celda.dia_abreviado}}</b>
                          {{celda.partido.fecha_hora | date:(matriz_densidad?'HH:mm':'dd/MM HH:mm')}}
                        </div>
                        <div class="celda-marcador" [style.color]="celda.color_texto_fecha">{{celda.jugado?celda.marcador:'?'}}</div>
                        <i *ngIf="celda.espejo" class="fas fa-exchange-alt celda-icono"></i>
                        <i *ngIf="celda.movible" (click)="quitarCeldaMatriz($event,celda)"
                           class="fa fa-times celda-quitar" title="Quitar este partido"></i>
                      </ng-container>
                      <i *ngIf="celda.estado=='vacia'" class="fa fa-plus celda-icono-agregar"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="matriz_equipos.length==0" class="text-center text-grey py-3">
              No hay equipos registrados para esta categoria y disciplina.
            </div>
            </div>
            <aside class="panel-cancha-activa" *ngIf="aplicacion.puede_crear">
              <div class="panel-cancha-titulo">Los cruces van a</div>
              <div class="panel-cancha-selectores">
                <div class="input-group input-group-sm panel-fecha" title="Día">
                  <input class="form-control" placeholder="dd/mm/yyyy" name="panel_fecha"
                         [ngModel]="fecha_panel" (ngModelChange)="cambiarFechaPanel($event)" ngbDatepicker #dp_panel="ngbDatepicker">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" (click)="dp_panel.toggle()" type="button"></button>
                  </div>
                </div>
                <select [compareWith]="compararObjectos" class="form-control form-control-sm" name="panel_cancha" title="Cancha"
                        [ngModel]="cancha_activa?cancha_activa.escenario:null" (ngModelChange)="cambiarCanchaPanel($event)">
                  <option [ngValue]="null" disabled>Cancha</option>
                  <option [ngValue]="escenario" *ngFor="let escenario of canchas_panel">{{escenario.nombre}}</option>
                </select>
              </div>
              <div class="panel-dia-semana" *ngIf="cancha_activa">{{matriz_dias_semana[cancha_activa.fecha.getDay()]}}</div>
              <ng-container *ngIf="cancha_activa; else sinCanchaActiva">
                <!-- cancha sin partidos ese dia: se elige desde que hora arranca -->
                <div class="panel-cancha-desde" *ngIf="partidos_cancha_activa.length==0">
                  <label class="mb-0 mr-1">Desde</label>
                  <select class="form-control form-control-sm" name="panel_desde"
                          [ngModel]="siguiente_cancha_activa" (ngModelChange)="cambiarDesdePanel($event)">
                    <option *ngFor="let hora of horas_disponibles" [ngValue]="hora">{{hora}}</option>
                  </select>
                </div>
                <div class="panel-cancha-lista">
                  <div class="panel-partido" *ngFor="let partido_cancha of partidos_cancha_activa">
                    <span class="panel-partido-hora">{{partido_cancha.fecha_hora | date:'HH:mm'}}</span>
                    <span class="panel-partido-logos">
                      <img [src]="rest_server+partido_cancha.equipo_1?.logo" [alt]="partido_cancha.equipo_1?.nombre" [title]="partido_cancha.equipo_1?.nombre" />
                      <img [src]="rest_server+partido_cancha.equipo_2?.logo" [alt]="partido_cancha.equipo_2?.nombre" [title]="partido_cancha.equipo_2?.nombre" />
                    </span>
                    <span class="panel-partido-equipos">
                      {{partido_cancha.equipo_1?.nombre}} <span class="text-grey">vs</span> {{partido_cancha.equipo_2?.nombre}}
                      <small class="d-block text-grey">{{partido_cancha.categoria?.nombre}}{{partido_cancha.arbitro?(' · '+partido_cancha.arbitro.persona.nombre_completo):' · sin árbitro'}}</small>
                    </span>
                    <a *ngIf="aplicacion.puede_eliminar && !partido_cancha.id_venta_equipo_1 && !partido_cancha.id_venta_equipo_2"
                       href="javascript:void(0)" class="panel-partido-quitar" title="Quitar" (click)="abrirPopupConfirmacionEliminacionPartido(partido_cancha)">
                      <i class="fa fa-times"></i>
                    </a>
                  </div>
                  <div class="panel-siguiente">
                    <span class="panel-partido-hora">{{siguiente_cancha_activa?siguiente_cancha_activa:'--:--'}}</span>
                    <span>{{siguiente_cancha_activa?'siguiente: toca un cruce en la matriz':'sin horario libre hasta medianoche'}}</span>
                  </div>
                </div>
                <div class="panel-cancha-botones">
                  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="deshacerTurno()" [disabled]="historial_turnos.length==0">
                    <i class="fas fa-undo mr-1"></i>Deshacer
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="dejarDeLlenar()">Dejar de llenar</button>
                </div>
              </ng-container>
              <ng-template #sinCanchaActiva>
                <div class="text-grey text-90 mt-2">Elige el día y la cancha: los cruces que marques en la matriz se agregan ahí, uno detrás del otro.</div>
              </ng-template>
            </aside>
            </div>
          </div>
        </div>
      </ng-container>

        <hr>
        <div class="row">
            <div class="col-12">
                <div class="row mb-2">
                  <div class="col-12">
                    <span class="text-grey text-90">
                      Cada columna es una fecha. Los partidos se ordenan por hora.
                    </span>
                  </div>
                </div>
                <!-- fixture general: junta partidos de distintos dias y canchas. Sale con lo marcado (con
                     las casillas de cada partido o de cada cancha, o con "Marcar todos"); sin
                     nada marcado, con todo el rol. Los botones de cada cancha generan solo esa cancha. -->
                <div class="row mb-2">
                  <div class="col-12 seleccion-rapida fixture-general">
                    <span class="text-grey text-90 mr-1">Marcar:</span>
                    <button type="button" (click)="marcarTodosPartidos()" class="btn btn-sm btn-outline-primary"
                            title="Marca todos los partidos de todas las canchas">
                      <i class="fas fa-check-double mr-1"></i>Marcar todos
                    </button>
                    <button type="button" (click)="quitarSeleccionPartidos()" class="btn btn-sm btn-outline-secondary"
                            [disabled]="contarSeleccionadosRol()==0" title="Desmarcar todos los partidos">
                      <i class="fas fa-times mr-1"></i>Quitar marcas
                    </button>
                    <span class="separador-fixture"></span>
                    <span class="text-grey text-90 mr-1">Fixture general:</span>
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="generarPdfRolPartidos(rol_partido,null,false)"
                            [title]="'Imagen para redes ('+textoAlcanceFixture()+')'">
                      <i class="fas fa-image mr-1"></i>Rol
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-success" (click)="generarPdfRolPartidos(rol_partido,null,true)"
                            [title]="'Resultados para redes ('+textoAlcanceFixture()+')'">
                      <i class="fas fa-image mr-1"></i>Resultados
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-success" (click)="copiarMensajeRolArbitros(rol_partido)"
                            [title]="'Copiar mensaje de WhatsApp para árbitros, sin equipos ('+textoAlcanceFixture()+')'">
                      <i class="fab fa-whatsapp mr-1"></i>Árbitros
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="generarPdfRolCompleto(rol_partido,true)"
                            [title]="'PDF del rol ('+textoAlcanceFixture()+')'">
                      <i class="fas fa-file-pdf mr-1"></i>PDF
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-warning" (click)="generarPdfPlanillasPartidos(rol_partido)"
                            [title]="'Imprimir planillas ('+textoAlcanceFixture()+')'">
                      <i class="fas fa-file-pdf mr-1"></i>Planillas
                    </button>
                    <span class="text-90 ml-1" [ngClass]="contarSeleccionadosRol()>0?'text-success-d1':'text-grey'">
                      {{contarSeleccionadosRol()>0?(contarSeleccionadosRol()+' partido(s) marcados'):'Sin marcas: sale todo el rol'}}
                    </span>
                  </div>
                </div>

                <!-- calendario: una columna por fecha y, dentro, un bloque por cancha -->
                <div *ngIf="vista_calendario" class="calendario-partidos">
                  <div class="columna-fecha" *ngFor="let columna of columnas_calendario">
                    <div class="cabecera-fecha" [style.background-color]="columna.color" [style.color]="columna.color_texto">
                      <div class="dia-fecha">{{columna.dia_literal}}</div>
                      <div class="numero-fecha">{{columna.fecha | date:'dd/MM/yyyy'}}</div>
                      <div class="conteo-fecha">{{columna.total}} partido(s)</div>
                    </div>

                    <!-- las canchas de una misma fecha van una al lado de la otra -->
                    <div class="canchas-fecha">
                    <div class="bloque-cancha" *ngFor="let cancha of columna.canchas"
                         [ngClass]="{'cancha-destino':partido_arrastrado && cancha.escenario}"
                         (dragover)="permitirSoltarPartido($event,cancha)"
                         (drop)="soltarPartidoCalendario(columna,cancha)">
                      <div class="cabecera-cancha">
                        <label class="seleccion-cancha" title="Marcar todos los partidos de esta cancha">
                          <input #sel_cancha type="checkbox" [checked]="canchaTodaSeleccionada(cancha)"
                                 (change)="seleccionarPartidosCancha(cancha,sel_cancha.checked)" />
                        </label>
                        <i class="fas fa-map-marker-alt mr-1"></i>{{cancha.nombre}}
                        <span *ngIf="esCanchaActiva(columna,cancha)" class="marca-abierta activa"
                              title="Los cruces que marques en la matriz van a esta cancha">Llenando</span>
                        <!-- una cancha agregada a mano que todavia no tiene partidos se puede quitar -->
                        <a *ngIf="cancha.abierta && cancha.partidos.length==0" href="javascript:void(0)" class="cerrar-abierta"
                           (click)="quitarCanchaVacia(columna,cancha)" title="Quitar esta cancha vacía">
                          <i class="fas fa-times"></i>
                        </a>
                        <!-- los botones de la cancha generan solo esta cancha en este dia: lo marcado en ella o,
                             sin marcas, la cancha completa. Para juntar canchas se usa el fixture general -->
                        <a href="javascript:void(0)" class="btn-imagen-cancha text-danger-m1"
                           [title]="'Imagen para redes de '+textoAlcanceCancha(cancha)"
                           (click)="generarPdfRolPartidos(rolDeCancha(rol_partido,cancha),null,false)">
                          <i class="fas fa-image"></i>
                        </a>
                        <a href="javascript:void(0)" class="btn-imagen-cancha text-success-m1"
                           [title]="'Resultados para redes de '+textoAlcanceCancha(cancha)"
                           (click)="generarPdfRolPartidos(rolDeCancha(rol_partido,cancha),null,true)">
                          <i class="fas fa-image"></i>
                        </a>
                        <a href="javascript:void(0)" class="btn-imagen-cancha text-success-d1"
                           [title]="'Copiar mensaje de WhatsApp para árbitros, sin equipos, de '+textoAlcanceCancha(cancha)"
                           (click)="copiarMensajeRolArbitros(rolDeCancha(rol_partido,cancha))">
                          <i class="fab fa-whatsapp"></i>
                        </a>
                        <a class="btn-imagen-cancha text-primary-d1" href="javascript:void(0)"
                           [title]="'PDF de '+textoAlcanceCancha(cancha)"
                           (click)="generarPdfRolCompleto(rolDeCancha(rol_partido,cancha),true)">
                          <i class="fas fa-file-pdf"></i>
                        </a>
                        <a href="javascript:void(0)" class="btn-imagen-cancha text-warning-d1"
                           [title]="'Imprimir planillas de '+textoAlcanceCancha(cancha)"
                           (click)="generarPdfPlanillasPartidos(rolDeCancha(rol_partido,cancha))">
                          <i class="fas fa-file-pdf"></i>
                        </a>
                        <span class="conteo-cancha">{{contarSeleccionadosCancha(cancha)}}/{{cancha.partidos.length}}</span>
                      </div>
                      <!-- asignacion masiva: lo elegido acá va a todos los partidos de esta cancha -->
                      <div class="asignacion-cancha">
                        <select [compareWith]="compararObjectos" class="form-control form-control-sm"
                                [name]="'arb_cancha_'+columna.clave+'_'+cancha.id"
                                [(ngModel)]="cancha.arbitro" (ngModelChange)="asignarArbitroCancha(cancha,$event)">
                          <option [ngValue]="undefined" disabled>Árbitro para toda la cancha</option>
                          <option [ngValue]="arbitro" *ngFor="let arbitro of arbitros">{{arbitro.persona.nombre_completo}}{{arbitro.disciplina?" - "+arbitro.disciplina.nombre:""}}</option>
                        </select>
                        <select [compareWith]="compararObjectos" class="form-control form-control-sm mt-1"
                                [name]="'mesa_cancha_'+columna.clave+'_'+cancha.id"
                                [(ngModel)]="cancha.mesa" (ngModelChange)="asignarMesaCancha(cancha,$event)">
                          <option [ngValue]="undefined" disabled>Mesa para toda la cancha</option>
                          <option [ngValue]="mesa" *ngFor="let mesa of mesas">{{mesa.persona.nombre_completo}}{{mesa.disciplina?" - "+mesa.disciplina.nombre:""}}</option>
                        </select>
                        <!-- cambio urgente de cancha: pasa lo marcado de esta cancha (o toda la cancha) a otra -->
                        <select class="form-control form-control-sm mt-1 mover-cancha" *ngIf="aplicacion.puede_crear && cancha.destinos.length>0"
                                [name]="'mover_cancha_'+columna.clave+'_'+cancha.id"
                                [title]="'Pasa a otra cancha '+(contarSeleccionadosCancha(cancha)>0?('los '+contarSeleccionadosCancha(cancha)+' partido(s) marcados'):'todos los partidos')+' de '+cancha.nombre+', conservando la hora si está libre'"
                                [(ngModel)]="cancha.mover_a" (ngModelChange)="moverPartidosCancha(cancha,$event)">
                          <option [ngValue]="null" disabled>{{contarSeleccionadosCancha(cancha)>0?('Mover '+contarSeleccionadosCancha(cancha)+' marcado(s) a…'):'Mover todos a otra cancha…'}}</option>
                          <option [ngValue]="escenario" *ngFor="let escenario of cancha.destinos">{{escenario.nombre}}</option>
                        </select>
                      </div>

                      <ng-container *ngFor="let partido of cancha.partidos">
                      <div class="tarjeta-partido"
                           [attr.draggable]="!partido.modificar && !partido.editando_hora && puedeMoverPartido(partido)?true:null"
                           (dragstart)="iniciarArrastrePartido($event,partido)"
                           (dragend)="terminarArrastrePartido()"
                           (dragover)="permitirSoltarSobrePartido($event,partido)"
                           (drop)="soltarSobrePartido($event,partido)"
                           [ngClass]="{'sin-guardar':!partido.id,
                                       'partido-movible':!partido.modificar && puedeMoverPartido(partido),
                                       'partido-destino':partido_arrastrado && partido_arrastrado!=partido}">
                        <div class="linea-superior">
                          <!-- marcar el partido lo incluye en la imagen para redes -->
                          <label class="seleccion-partido" title="Incluir en la imagen para redes">
                            <input #sel_partido type="checkbox" [checked]="partido.selected"
                                   (change)="alternarSeleccionPartido(partido,sel_partido.checked)" />
                          </label>
                          <!-- la hora se cambia acá mismo, sin entrar a modificar el partido -->
                          <!-- desplegable en vez de un campo de hora nativo: dentro de una tarjeta
                               arrastrable el campo nativo no dejaba editar. Mientras el puntero
                               esta encima se suspende el arrastre. -->
                          <select *ngIf="puedeMoverPartido(partido)" class="hora-partido hora-editable"
                                  title="Cambiar la hora"
                                  [ngModel]="horaTextoPartido(partido)" [ngModelOptions]="{standalone:true}"
                                  (ngModelChange)="cambiarHoraPartido(partido,$event)"
                                  (mouseenter)="partido.editando_hora=true"
                                  (mouseleave)="partido.editando_hora=false">
                            <option *ngIf="horaFueraDeGrilla(partido)" [value]="horaTextoPartido(partido)">{{horaTextoPartido(partido)}}</option>
                            <option *ngFor="let hora of horas_disponibles" [value]="hora">{{hora}}</option>
                          </select>
                          <span *ngIf="!puedeMoverPartido(partido)" class="hora-partido"
                                [title]="motivoPartidoBloqueado(partido)">
                            {{partido.fecha_hora | date:'HH:mm'}} <i class="fa fa-lock text-90"></i>
                          </span>
                          <span class="etiqueta-partido" *ngIf="partido.categoria"
                                [style.background-color]="colorClase(partido.categoria)"
                                [style.color]="colorClase(partido.categoria)?'#ffffff':null">{{partido.categoria.nombre}}</span>
                          <span class="etiqueta-partido" *ngIf="partido.disciplina"
                                [style.background-color]="colorClase(partido.disciplina)"
                                [style.color]="colorClase(partido.disciplina)?'#ffffff':null">{{partido.disciplina.nombre}}</span>
                        </div>

                        <!-- lectura -->
                        <ng-container *ngIf="!partido.modificar">
                          <div class="equipos-partido">
                            <div class="equipo-partido">
                              <!-- el escudo ayuda a reconocer al equipo de un vistazo en la tarjeta -->
                              <img *ngIf="partido.equipo_1.logo" class="escudo-calendario"
                                   [src]="rest_server+partido.equipo_1.logo" [alt]="partido.equipo_1.nombre" />
                              <span class="nombre-equipo">{{partido.equipo_1.nombre}}</span>
                              <span class="marcador-equipo"
                                    [ngClass]="{'gano':partido.marcador_equipo_1>partido.marcador_equipo_2,
                                                'perdio':partido.marcador_equipo_1<partido.marcador_equipo_2}">
                                {{partido.marcador_equipo_1!=null?partido.marcador_equipo_1:'-'}}
                              </span>
                            </div>
                            <div class="equipo-partido">
                              <img *ngIf="partido.equipo_2.logo" class="escudo-calendario"
                                   [src]="rest_server+partido.equipo_2.logo" [alt]="partido.equipo_2.nombre" />
                              <span class="nombre-equipo">{{partido.equipo_2.nombre}}</span>
                              <span class="marcador-equipo"
                                    [ngClass]="{'gano':partido.marcador_equipo_2>partido.marcador_equipo_1,
                                                'perdio':partido.marcador_equipo_2<partido.marcador_equipo_1}">
                                {{partido.marcador_equipo_2!=null?partido.marcador_equipo_2:'-'}}
                              </span>
                            </div>
                          </div>
                        </ng-container>

                        <!-- edicion: los mismos campos que ofrecia la tabla -->
                        <ng-container *ngIf="partido.modificar">
                          <div class="edicion-partido">
                            <label>Categoria</label>
                            <select [compareWith]="compararObjectos" class="form-control form-control-sm" name="cat_ed"
                                    [(ngModel)]="partido.categoria" (change)="cambiarCategoriaModificacion(partido)">
                              <option [ngValue]="categoria" *ngFor="let categoria of tipo_categoria.clases">{{categoria.nombre}}</option>
                            </select>
                            <label>Fase</label>
                            <select [compareWith]="compararObjectos" class="form-control form-control-sm" name="fase_ed" [(ngModel)]="partido.fase">
                              <option [ngValue]="fase" *ngFor="let fase of tipo_fase.clases">{{fase.nombre}}</option>
                            </select>
                            <label>Disciplina</label>
                            <select [compareWith]="compararObjectos" class="form-control form-control-sm" name="dis_ed" [(ngModel)]="partido.disciplina">
                              <option [ngValue]="disciplina" *ngFor="let disciplina of tipo_disciplina.clases">{{disciplina.nombre}}</option>
                            </select>
                            <label>Equipo 1</label>
                            <select [compareWith]="compararObjectos" class="form-control form-control-sm" name="eq1_ed" [(ngModel)]="partido.equipo_1_c">
                              <option [ngValue]="equipo" *ngFor="let equipo of partido.equipos">{{equipo.nombre}}</option>
                            </select>
                            <label>Equipo 2</label>
                            <select [compareWith]="compararObjectos" class="form-control form-control-sm" name="eq2_ed" [(ngModel)]="partido.equipo_2_c">
                              <option [ngValue]="equipo" *ngFor="let equipo of partido.equipos">{{equipo.nombre}}</option>
                            </select>
                            <label>Fecha y hora</label>
                            <div class="input-group input-group-sm">
                              <input name="fecha_ed" class="form-control form-control-sm" placeholder="dd/mm/yyyy"
                                     [(ngModel)]="partido.fecha_hora_texto" ngbDatepicker #dc="ngbDatepicker">
                              <div class="input-group-append">
                                <button class="btn btn-sm btn-outline-secondary calendar" (click)="dc.toggle()" type="button"></button>
                              </div>
                            </div>
                            <ngb-timepicker [(ngModel)]="partido.hora" [spinners]="false"></ngb-timepicker>
                            <label>Escenario</label>
                            <select [compareWith]="compararObjectos" class="form-control form-control-sm" name="esc_ed" [(ngModel)]="partido.escenario">
                              <option [ngValue]="null">Seleccionar escenario</option>
                              <option [ngValue]="escenario" *ngFor="let escenario of escenarios">{{escenario.nombre}}</option>
                            </select>
                          </div>
                        </ng-container>

                        <select [compareWith]="compararObjectos" class="form-control form-control-sm mt-1"
                                name="arbitro_cal" [(ngModel)]="partido.arbitro">
                          <option [ngValue]="null">Sin árbitro</option>
                          <option [ngValue]="arbitro" *ngFor="let arbitro of arbitros">{{arbitro.persona.nombre_completo}}{{arbitro.disciplina?" - "+arbitro.disciplina.nombre:""}}</option>
                        </select>
                        <select [compareWith]="compararObjectos" class="form-control form-control-sm mt-1"
                                name="mesa_cal" [(ngModel)]="partido.mesa">
                          <option [ngValue]="null">Sin mesa</option>
                          <option [ngValue]="mesa" *ngFor="let mesa of mesas">{{mesa.persona.nombre_completo}}{{mesa.disciplina?" - "+mesa.disciplina.nombre:""}}</option>
                        </select>

                        <div class="acciones-partido">
                          <a *ngIf="aplicacion.puede_crear && !partido.modificar && !partido.id_venta_equipo_1 && !partido.id_venta_equipo_2"
                             title="Modificar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="modificarPartido(partido)">
                            <i class="fas fa-pencil-alt"></i>
                          </a>
                          <a *ngIf="partido.modificar" title="Confirmar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="establecerPartidoEquipos(partido)">
                            <i class="fas fa-check"></i>
                          </a>
                          <a title="Planilla" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="generarPdfPlanillaPartido(partido)">
                            <i class="fas fa-file-pdf"></i>
                          </a>
                          <a title="Resultados" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="abrirModalResultados(partido)">
                            <i class="fas fa-poll"></i>
                          </a>
                          <a title="Copiar enlace" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="copiarEnlace(partido)">
                            <i class="fas fa-copy"></i>
                          </a>
                          <a *ngIf="aplicacion.puede_eliminar && !partido.id_venta_equipo_1 && !partido.id_venta_equipo_2"
                             title="Quitar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacionPartido(partido)">
                            <i class="fa fa-trash-alt"></i>
                          </a>
                        </div>
                      </div>
                      </ng-container>
                      <!-- siguiente turno de la cancha: tocarlo hace que los cruces de la matriz vayan aca -->
                      <div *ngIf="cancha.escenario && aplicacion.puede_crear" class="turno-vacio"
                           [ngClass]="{'turno-siguiente':esCanchaActiva(columna,cancha)}" (click)="activarCancha(columna,cancha)"
                           [title]="esCanchaActiva(columna,cancha)?'Los cruces que marques en la matriz van a esta cancha':'Tocalo para llenar esta cancha desde la matriz'">
                        <span class="hora-turno">{{cancha.siguiente?cancha.siguiente:'--:--'}}</span>
                        <span>{{esCanchaActiva(columna,cancha)?'siguiente… (matriz)':'+ siguiente'}}</span>
                      </div>
                    </div>
                    </div>
                  </div>
                  <div *ngIf="columnas_calendario.length==0" class="text-grey py-4 px-2">
                    Todavía no hay partidos en este rol.
                  </div>
                </div>

            </div>
        </div>
    </div>
</ng-template>

<ng-template #modal_resultado_partido let-modal>
  <div class="modal-header card-header">
      <div class="col-md-8 col-xs-8">
          <span class="text-blue text-125">Resultado Partido</span>
      </div>
      <div class="col-md-6 col-xs-6">
          <button (click)="guardarResultadoPartido()" class="btn btn-primary"  >
              <i class="fa fa-save text-110 mr-1"></i>
          </button>&nbsp;
          <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
              <i class="fa fa-times red2 text-110 mr-1"></i>
          </button>
      </div>
  </div>
  <div class="modal-body card-body">
      <div class="row bgc-primary-d1 text-white px-3 py-25">
          <div class="col-5 col-md-2 text-right">
            <label>{{partido.equipo_1.nombre}}</label>
          </div>
          <div class="col-3 col-md-2" >
            <label>¿Dio W.O.? <input (change)="establecerWOEquipo1()" name="switch-field-eq1" class="ace-switch input-lg ace-switch-sino bgc-green-d1" type="checkbox" [(ngModel)]="partido.w_o_equipo_1.es_wo"/></label>
            <button *ngIf="partido.id && partido.w_o_equipo_2.es_wo && !partido.w_o_equipo_1.id_venta" type="button" (click)="generarVentaWO(partido,partido.equipo_1,null,partido.equipo_2)" class="btn btn-success btn-sm">
              <i class="fas fa-money-bill-alt"></i>
            </button>
          </div>
          <div class="col-4 col-md-1 p-0" >
            <input [disabled]="partido.w_o_equipo_1.es_wo || partido.w_o_equipo_2.es_wo" type="number" min="0" step="0" class="form-control" name="marcador_1" [(ngModel)]="partido.marcador_equipo_1" [ngClass]="{'brc-danger-m1 border-3':(partido.marcador_equipo_1===null || partido.marcador_equipo_1 < 0)}">
          </div>
          <div class="col-12 col-md-2 text-center">
              <label>VS</label>
          </div>
          <div class="col-4 col-md-1 p-0">
            <input [disabled]="partido.w_o_equipo_1.es_wo || partido.w_o_equipo_2.es_wo" type="number" min="0" step="0" class="form-control" name="marcador_2" [(ngModel)]="partido.marcador_equipo_2" [ngClass]="{'brc-danger-m1 border-3':(partido.marcador_equipo_2===null || partido.marcador_equipo_2 < 0)}">
          </div>
          <div class="col-3 col-md-2" >
            <label>¿Dio W.O.? <input (change)="establecerWOEquipo2()" name="switch-field-eq2" class="ace-switch input-lg ace-switch-sino bgc-green-d1" type="checkbox" [(ngModel)]="partido.w_o_equipo_2.es_wo"/></label>
            <button *ngIf="partido.id && partido.w_o_equipo_1.es_wo && !partido.w_o_equipo_2.id_venta" type="button" (click)="generarVentaWO(partido,null,partido.equipo_2,partido.equipo_1)" class="btn btn-success btn-sm">
              <i class="fas fa-money-bill-alt"></i>
            </button>
          </div>
          <div class="col-5 col-md-2">
            <label>{{partido.equipo_2.nombre}}</label>
        </div>
      </div>
      <hr>
      <div class="row bgc-yellow-d1 text-black pt-2 p-0">
        <div class="col-6 col-md-6">
          <div class="row">
            <div class="col-12 col-md-3 p-0 pl-1">
              <label>Amarillas</label><br>
              <a (click)="crearNuevoJugador(partido.equipo_1)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)">
                <i class="fa fa-plus text-105"></i>
              </a>
              <a *ngIf="partido.eq_1_jugador_amarilla" (click)="modificarJugador(partido.equipo_1,partido.eq_1_jugador_amarilla)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)">
                <i class="fa fa-pencil-alt text-105"></i>
              </a>
              <a *ngIf="partido.eq_1_jugador_amarilla" (click)="abrirPopupConfirmacionEliminacionJugador(partido.eq_1_jugador_amarilla)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)">
                <i class="fa fa-trash text-105"></i>
              </a>
            </div>
            <div class="col-10 col-md-7 p-0 pl-1">
              <select [compareWith]="compararObjectos" class="form-control" name="eq_1_jugador_amarilla" [(ngModel)]="partido.eq_1_jugador_amarilla">
                <option [ngValue]="jugador" *ngFor="let jugador of partido.equipo_1.jugadores | orderBy:'jugador.persona.nombre_completo':false">{{jugador.jugador.persona.nombre_completo}}</option>
              </select>
            </div>
            <div class="col-2 col-md-2 p-0 pl-1">
              <button type="button" (click)="agregarJugadorAmarillaEq1(partido.eq_1_jugador_amarilla)" class="btn btn-success btn-sm">
                <i class="ace-icon fa fa-arrow-down bigger-110"></i>
              </button>
            </div>
            <div class="col-12 p-0">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Jugador</th>
                    <th>
                      <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                      <div class="fht-cell"></div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let amarilla_equipo_1 of partido.lista_amarillas_equipo_1; let i=index;">
                    <th>{{amarilla_equipo_1.persona.nombre_completo}}</th>
                    <td>
                      <a title="Generar Venta Amarilla" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" *ngIf="aplicacion_ventas.puede_crear && partido.id && !amarilla_equipo_1.id_venta" (click)="generarVentaJugadorAmarilla(partido,partido.equipo_1,null,amarilla_equipo_1)">
                        <i class="fas fa-money-bill-alt"></i>
                      </a>
                      <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacionAmarillaEq1(amarilla_equipo_1)">
                        <i class="fa fa-trash-alt text-105"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-6">
          <div class="row">
            <div class="col-12 col-md-3 p-0 pl-1">
              <label>Amarillas</label><br>
              <a (click)="crearNuevoJugador(partido.equipo_2)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)">
                <i class="fa fa-plus text-105"></i>
              </a>
              <a *ngIf="partido.eq_2_jugador_amarilla" (click)="modificarJugador(partido.equipo_2,partido.eq_2_jugador_amarilla)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)">
                <i class="fa fa-pencil-alt text-105"></i>
              </a>
              <a *ngIf="partido.eq_2_jugador_amarilla" (click)="abrirPopupConfirmacionEliminacionJugador(partido.eq_2_jugador_amarilla)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)">
                <i class="fa fa-trash text-105"></i>
              </a>
            </div>
            <div class="col-10 col-md-7 p-0 pl-1">
              <select [compareWith]="compararObjectos" class="form-control" name="eq_2_jugador_amarilla" [(ngModel)]="partido.eq_2_jugador_amarilla">
                <option [ngValue]="jugador" *ngFor="let jugador of partido.equipo_2.jugadores | orderBy:'jugador.persona.nombre_completo':false">{{jugador.jugador.persona.nombre_completo}}</option>
              </select>
            </div>
            <div class="col-2 col-md-2 p-0 pl-1">
              <button type="button" (click)="agregarJugadorAmarillaEq2(partido.eq_2_jugador_amarilla)" class="btn btn-success btn-sm">
                <i class="ace-icon fa fa-arrow-down bigger-110"></i>
              </button>
            </div>
            <div class="col-12 p-0">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Jugador</th>
                    <th>
                      <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                      <div class="fht-cell"></div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let amarilla_equipo_2 of partido.lista_amarillas_equipo_2; let i=index;">                    
                    <th>{{amarilla_equipo_2.persona.nombre_completo}}</th>
                    <td>
                      <a title="Generar Venta Amarilla" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" *ngIf="aplicacion_ventas.puede_crear && partido.id && !amarilla_equipo_2.id_venta" (click)="generarVentaJugadorAmarilla(partido,null,partido.equipo_2,amarilla_equipo_2)">
                        <i class="fas fa-money-bill-alt"></i>
                      </a>
                      <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacionAmarillaEq2(amarilla_equipo_2)">
                        <i class="fa fa-trash-alt text-105"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row bgc-danger-d1 text-white pt-2 p-0">
        <div class="col-6 col-md-6">
          <div class="row">
            <div class="col-12 col-md-3 p-0 pl-1">
              <label>Rojas</label><br>
              <a (click)="crearNuevoJugador(partido.equipo_1)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-plus text-105"></i>
              </a>
              <a *ngIf="partido.eq_1_jugador_roja" (click)="modificarJugador(partido.equipo_1,partido.eq_1_jugador_roja)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-pencil-alt text-105"></i>
              </a>
              <a *ngIf="partido.eq_1_jugador_roja" (click)="abrirPopupConfirmacionEliminacionJugador(partido.eq_1_jugador_roja)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-trash text-105"></i>
              </a>
            </div>
            <div class="col-10 col-md-7 p-0 pl-1">
              <select [compareWith]="compararObjectos" class="form-control" name="eq_1_jugador_roja" [(ngModel)]="partido.eq_1_jugador_roja">
                <option [ngValue]="jugador" *ngFor="let jugador of partido.equipo_1.jugadores | orderBy:'jugador.persona.nombre_completo':false">{{jugador.jugador.persona.nombre_completo}}</option>
              </select>
            </div>
            <div class="col-2 col-md-2 p-0 pl-1">
              <button type="button" (click)="agregarJugadorRojaEq1(partido.eq_1_jugador_roja)" class="btn btn-success btn-sm">
                <i class="ace-icon fa fa-arrow-down bigger-110"></i>
              </button>
            </div>
            <div class="col-12 p-0">
              <table class="table table-striped table-hover">
                <thead class="text-white">
                  <tr>
                    <th><label>Jugador</label></th>
                    <th>
                      <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                      <div class="fht-cell"></div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let roja_equipo_1 of partido.lista_rojas_equipo_1; let i=index;">
                    <th>{{roja_equipo_1.persona.nombre_completo}}</th>
                    <td>
                      <a title="Generar Venta Roja" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" *ngIf="aplicacion_ventas.puede_crear && partido.id && !roja_equipo_1.id_venta" (click)="generarVentaJugadorRoja(partido,partido.equipo_1,null,roja_equipo_1)">
                        <i class="fas fa-money-bill-alt"></i>
                      </a>
                      <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacionRojaEq1(roja_equipo_1)">
                        <i class="fa fa-trash-alt text-105"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-6">
          <div class="row">
            <div class="col-12 col-md-3 p-0 pl-1">
              <label>Rojas</label><br>
              <a (click)="crearNuevoJugador(partido.equipo_2)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-plus text-105"></i>
              </a>
              <a *ngIf="partido.eq_2_jugador_roja" (click)="modificarJugador(partido.equipo_2,partido.eq_2_jugador_roja)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-pencil-alt text-105"></i>
              </a>
              <a *ngIf="partido.eq_2_jugador_roja" (click)="abrirPopupConfirmacionEliminacionJugador(partido.eq_2_jugador_roja)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-trash text-105"></i>
              </a>
            </div>
            <div class="col-10 col-md-7 p-0 pl-1">
              <select [compareWith]="compararObjectos" class="form-control" name="eq_2_jugador_roja" [(ngModel)]="partido.eq_2_jugador_roja">
                <option [ngValue]="jugador" *ngFor="let jugador of partido.equipo_2.jugadores | orderBy:'jugador.persona.nombre_completo':false">{{jugador.jugador.persona.nombre_completo}}</option>
              </select>
            </div>
            <div class="col-2 col-md-2 p-0 pl-1">
              <button type="button" (click)="agregarJugadorRojaEq2(partido.eq_2_jugador_roja)" class="btn btn-success btn-sm">
                <i class="ace-icon fa fa-arrow-down bigger-110"></i>
              </button>
            </div>
            <div class="col-12 p-0">
              <table class="table table-striped table-hover">
                <thead class="text-white">
                  <tr>
                    <th>Jugador</th>
                    <th>
                      <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                      <div class="fht-cell"></div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let roja_equipo_2 of partido.lista_rojas_equipo_2; let i=index;">
                    <th>{{roja_equipo_2.persona.nombre_completo}}</th>
                    <td>
                      <a title="Generar Venta Roja" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" *ngIf="aplicacion_ventas.puede_crear && partido.id && !roja_equipo_2.id_venta" (click)="generarVentaJugadorRoja(partido,null,partido.equipo_2,roja_equipo_2)">
                        <i class="fas fa-money-bill-alt"></i>
                      </a>
                      <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacionRojaEq2(roja_equipo_2)">
                        <i class="fa fa-trash-alt text-105"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row bgc-purple-d1 text-white pt-2 p-0">
        <div class="col-6 col-md-6">
          <div class="row">
            <div class="col-12 col-md-3 p-0 pl-1">
              <label>Marcador</label><br>
              <a (click)="crearNuevoJugador(partido.equipo_1)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-plus text-105"></i>
              </a>
              <a *ngIf="partido.eq_1_jugador_marcador" (click)="modificarJugador(partido.equipo_1,partido.eq_1_jugador_marcador)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-pencil-alt text-105"></i>
              </a>
              <a *ngIf="partido.eq_1_jugador_marcador" (click)="abrirPopupConfirmacionEliminacionJugador(partido.eq_1_jugador_marcador)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-trash text-105"></i>
              </a>
            </div>
            <div class="col-12 col-md-5 p-0 pl-1">
              <select [compareWith]="compararObjectos" class="form-control" name="eq_1_jugador_marcador" [(ngModel)]="partido.eq_1_jugador_marcador">
                <option [ngValue]="jugador" *ngFor="let jugador of partido.equipo_1.jugadores | orderBy:'jugador.persona.nombre_completo':false">{{jugador.jugador.persona.nombre_completo}}</option>
              </select>
            </div>
            <div class="col-8 col-md-3">
              <input type="number" min="1" step="0" class="form-control" name="marcador_jugador_1" [(ngModel)]="partido.marcador_jugador_1">
            </div>
            <div class="col-4 col-md-1">
              <button type="button" (click)="agregarJugadorMarcadorEq1(partido.eq_1_jugador_marcador,partido.marcador_jugador_1)" class="btn btn-success btn-sm">
                <i class="ace-icon fa fa-arrow-down bigger-110"></i>
              </button>
            </div>
            <div class="col-12 p-0 pl-1">
              <table class="table table-striped table-hover">
                <thead class="text-white">
                  <tr>
                    <th><label>Jugador</label></th>
                    <th><label>Marc.</label></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let marcador_equipo_1 of partido.lista_marcador_equipo_1; let i=index;">
                    <th>{{marcador_equipo_1.jugador.persona.nombre_completo}}</th>
                    <th>
                      {{marcador_equipo_1.marcador}}
                      <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacionMarcadorEq1(marcador_equipo_1)">
                        <i class="fa fa-trash-alt text-105"></i>
                      </a>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-6">
          <div class="row">
            <div class="col-12 col-md-3 p-0 pl-1">
              <label>Marcador</label><br>
              <a (click)="crearNuevoJugador(partido.equipo_2)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-plus text-105"></i>
              </a>
              <a *ngIf="partido.eq_2_jugador_marcador" (click)="modificarJugador(partido.equipo_2,partido.eq_2_jugador_marcador)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-pencil-alt text-105"></i>
              </a>
              <a *ngIf="partido.eq_2_jugador_marcador" (click)="abrirPopupConfirmacionEliminacionJugador(partido.eq_2_jugador_marcador)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)">
                <i class="fa fa-trash text-105"></i>
              </a>
            </div>
            <div class="col-12 col-md-5 p-0 pl-1">
              <select [compareWith]="compararObjectos" class="form-control" name="eq_2_jugador_marcador" [(ngModel)]="partido.eq_2_jugador_marcador">
                <option [ngValue]="jugador" *ngFor="let jugador of partido.equipo_2.jugadores | orderBy:'jugador.persona.nombre_completo':false"
                >{{jugador.jugador.persona.nombre_completo}}</option>
              </select>
            </div>
            <div class="col-8 col-md-3 ">
              <input type="number" min="1" step="0" class="form-control" name="marcador_jugador_2" [(ngModel)]="partido.marcador_jugador_2">
            </div>
            <div class="col-4 col-md-1 ">
              <button type="button" (click)="agregarJugadorMarcadorEq2(partido.eq_2_jugador_marcador,partido.marcador_jugador_2)" class="btn btn-success btn-sm">
                <i class="ace-icon fa fa-arrow-down bigger-110"></i>
              </button>
            </div>
            <div class="col-12 p-0 pl-1">
              <table class="table table-striped table-hover">
                <thead class="text-white">
                  <tr>
                    <th><label>Jugador</label></th>
                    <th><label>Marc.</label></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let marcador_equipo_2 of partido.lista_marcador_equipo_2; let i=index;">
                    <th>{{marcador_equipo_2.jugador.persona.nombre_completo}}</th>
                    <th>
                      {{marcador_equipo_2.marcador}}
                      <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacionMarcadorEq2(marcador_equipo_2)">
                        <i class="fa fa-trash-alt text-105"></i>
                      </a>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
  </div>
</ng-template>

<ng-template #modal_tabla_posiciones let-modal>
  <div class="modal-header card-header">
      <div class="col-md-8 col-xs-8">
          <span class="text-blue text-125">Tabla de Posiciones</span>
      </div>
      <div class="col-md-6 col-xs-6">
          <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
              <i class="fa fa-times red2 text-110 mr-1"></i>
          </button>
      </div>
  </div>
  <div class="modal-body card-body">
      <div class="row bgc-primary-d1 text-white px-3 py-25">
          <div class="col-md-2">
              <label>Campeonato</label>
              <select [compareWith]="compararObjectos" class="form-control" required name="campeonato" [(ngModel)]="tabla_posiciones.campeonato">
                <option [ngValue]="campeonato" *ngFor="let campeonato of campeonatos">{{campeonato.nombre}}</option>
              </select>
          </div>
          <div class="col-md-2">
            <label>Disciplina</label>
            <select [compareWith]="compararObjectos" class="form-control" required name="disciplina" [(ngModel)]="tabla_posiciones.disciplina">
              <option [ngValue]="disciplina" *ngFor="let disciplina of tipo_disciplina.clases">{{disciplina.nombre}}</option>
            </select>
        </div>
          <div class="col-md-2 p-0">
              <label>Categoria</label>
              <select [compareWith]="compararObjectos" class="form-control" required name="categoria" [(ngModel)]="tabla_posiciones.categoria">
                <option [ngValue]="categoria" *ngFor="let categoria of tipo_categoria.clases">{{categoria.nombre}}</option>
              </select>
          </div>
          <div class="col-md-3">
            <label>Fase</label>
            <select [compareWith]="compararObjectos" class="form-control" required name="fase" [(ngModel)]="tabla_posiciones.fase">
              <option [ngValue]="fase" *ngFor="let fase of tipo_fase.clases">{{fase.nombre}}</option>
            </select>
          </div>
          <div class="col-md-3 p-0">
            <button (click)="buscarTablaPosiciones()" class="btn btn-xs btn-app btn-success my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Agregar">
              <i class="d-block h-4 fa fa-search text-150"></i>
            </button>&nbsp;
            <button (click)="generarImagenTablaPosiciones()" class="btn btn-xs btn-app btn-danger my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Descargar imagen y publicar en la página del campeonato">
              <i class="d-block h-4 fa fa-image text-150"></i>
            </button>
          </div>

      </div>
      <hr>
      <div class="row">
          <div class="col-12">
              <table class="table text-dark-m2 text-95 table-bordered table-hover table-striped table-responsive" id="table">
                  <thead class="bgc-white text-grey text-uppercase text-80">
                    <tr>
                      <th>N°</th>
                      <th>Equipo</th>
                      <th>PJ</th>
                      <th>G</th>
                      <th>E</th>
                      <th>P</th>
                      <th>MF</th>
                      <th>MC</th>
                      <th>MD</th>
                      <th>PTS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let equipo of equipos; let i=index;">
                      <tr>
                        <td>
                          {{(i+1)}}
                          <input type="color" name="{{(i+1)}}" [(ngModel)]="equipo.clasificacion" class="form-control" />
                        </td>
                        <td>
                            {{equipo.nombre}}
                        </td>
                        <td>
                          {{equipo.partidos_jugados}}
                        </td>
                        <td>
                          {{equipo.victorias}}
                        </td>
                        <td >
                          {{equipo.empates}}
                        </td>
                        <td>
                          {{equipo.derrotas}}
                        </td>
                        <td>
                          {{equipo.marcador_a_favor}}
                        </td>
                        <td>
                          {{equipo.marcador_contra}}
                        </td>
                        <td>
                          {{equipo.marcador_diferencia}}
                        </td>
                        <td>
                          {{equipo.puntos}}
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
          </div>
      </div>
  </div>
</ng-template>

<ng-template #modal_rol_partidos_arbitros let-modal>
  <div class="modal-header card-header">
      <div class="col-md-8 col-xs-8">
          <span class="text-blue text-125">Rol Partidos Arbitro</span>
      </div>
      <div class="col-md-6 col-xs-6">
          <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
              <i class="fa fa-times red2 text-110 mr-1"></i>
          </button>
      </div>
  </div>
  <div class="modal-body card-body">
      <div class="row bgc-primary-d1 text-white px-3 py-25">
          <div class="col-md-3">
              <label>Campeonato</label>
              <select [compareWith]="compararObjectos" class="form-control" required name="campeonato" [(ngModel)]="rol_partido_arbitro.campeonato">
                <option [ngValue]="campeonato" *ngFor="let campeonato of filter.campeonatos">{{campeonato.nombre}}</option>
              </select>
          </div>
          <div class="col-md-2">
              <label>Arbitro</label>
              <select [compareWith]="compararObjectos" class="form-control" required name="arbitro" [(ngModel)]="rol_partido_arbitro.arbitro">
                <option [ngValue]="null" [selected]="true">Seleccionar arbitro</option>
                  <option [ngValue]="arbitro" *ngFor="let arbitro of arbitros">{{arbitro.persona.nombre_completo}}{{arbitro.disciplina?" - "+arbitro.disciplina.nombre:""}}</option>
              </select>
          </div>
          <div class="col-md-2 col-sm-12">
            <label for="feini">Desde </label>&nbsp;
            <div class="input-group">
                <input required id="feini" name="birthday" class="form-control" placeholder="dd/mm/yyyy"
                        name="dp" [(ngModel)]="rol_partido_arbitro.fecha_inicio" ngbDatepicker #fi="ngbDatepicker">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" (click)="fi.toggle()" type="button"></button>
                </div>
            </div>  
          </div>
          <div class="col-md-2 col-sm-12">
            <label for="fefin">Hasta </label>&nbsp;
            <div class="input-group">
                <input required id="fefin" name="birthday" class="form-control" placeholder="dd/mm/yyyy"
                        name="dp" [(ngModel)]="rol_partido_arbitro.fecha_fin" ngbDatepicker #d="ngbDatepicker">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                </div>
            </div>  
          </div>
          <div class="col-md-3 p-0">
            <button (click)="buscarPartidosArbitro()" class="btn btn-xs btn-app btn-success my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Agregar">
              <i class="d-block h-4 fa fa-search text-150"></i>
            </button>&nbsp;
            <button (click)="generarPdfRolPartidosArbitro()" class="btn btn-xs btn-app btn-danger my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Agregar">
              <i class="d-block h-4 fa fa-file-pdf text-150"></i>
            </button>&nbsp;
            <button (click)="copiarMensajeRolPartidosArbitro()" class="btn btn-xs btn-app btn-success my-1" type="button" title="Copiar mensaje de WhatsApp con el rol del árbitro">
              <i class="d-block h-4 fab fa-whatsapp text-150"></i>
            </button>
          </div>

      </div>
      <hr>
      <div class="row">
          <div class="col-12">
              <table class="table text-dark-m2 text-95 table-bordered table-hover table-striped table-responsive" id="table">
                  <thead class="bgc-white text-grey text-uppercase text-80">
                    <tr>
                      <th class="text-center pr-0">
                        <label class="py-0">
                          <input [(ngModel)]="allItemsSelected" (change)="selectAllItems(rol_partido_arbitro.partidos)" type="checkbox" class="align-bottom mb-n1 border-2 text-dark-m3" />
                        </label>
                      </th>
                      <th>N°</th>
                      <th>Campeonato</th>
                      <th>Fecha - Hora</th>
                      <th>Equipo 1</th>
                      <th>Equipo 2</th>
                      <th>Escenario</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let partido of rol_partido_arbitro.partidos; let i=index;">
                      <tr>
                        <td>
                          <label>
                            <input [(ngModel)]="partido.selected" (change)="addItemToSelected(partido)" type="checkbox" class="align-middle" />
                          </label>
                        </td>
                        <td>
                          {{(i+1)}}
                        </td>
                        <td>
                            {{partido.rol_partido.campeonato.nombre}}
                        </td>
                        <td>
                          {{partido.fecha_hora | date:'dd/MM/yyyy HH:mm'}}
                        </td>
                        <td>
                          {{partido.equipo_1.nombre}}
                        </td>
                        <td>
                          {{partido.equipo_2.nombre}}
                        </td>
                        <td>
                          {{partido.escenario.nombre}}
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
          </div>
      </div>
  </div>
</ng-template>

<ng-template #modal_tabla_goleadores let-modal>
  <div class="modal-header card-header">
      <div class="col-md-8 col-xs-8">
          <span class="text-blue text-125">Tabla de Goleadores</span>
      </div>
      <div class="col-md-6 col-xs-6">
          <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
              <i class="fa fa-times red2 text-110 mr-1"></i>
          </button>
      </div>
  </div>
  <div class="modal-body card-body">
      <div class="row bgc-primary-d1 text-white px-3 py-25">
          <div class="col-md-3">
              <label>Campeonato</label>
              <select [compareWith]="compararObjectos" class="form-control" required name="campeonato" [(ngModel)]="tabla_posiciones.campeonato">
                <option [ngValue]="campeonato" *ngFor="let campeonato of campeonatos">{{campeonato.nombre}}</option>
              </select>
          </div>
          <div class="col-md-3">
            <label>Disciplina</label>
            <select [compareWith]="compararObjectos" class="form-control" required name="disciplina" [(ngModel)]="tabla_posiciones.disciplina">
              <option [ngValue]="disciplina" *ngFor="let disciplina of tipo_disciplina.clases">{{disciplina.nombre}}</option>
            </select>
        </div>
          <div class="col-md-2 p-0">
              <label>Categoria</label>
              <select [compareWith]="compararObjectos" class="form-control" required name="categoria" [(ngModel)]="tabla_posiciones.categoria">
                <option [ngValue]="categoria" *ngFor="let categoria of tipo_categoria.clases">{{categoria.nombre}}</option>
              </select>
          </div>
          <div class="col-md-4 p-0">
            <button (click)="buscarTablaGoleadores()" class="btn btn-xs btn-app btn-success my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Agregar">
              <i class="d-block h-4 fa fa-search text-150"></i>
            </button>&nbsp;
            <button (click)="generarPdfTablaGoleadores()" class="btn btn-xs btn-app btn-danger my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Agregar">
              <i class="d-block h-4 fa fa-file-pdf text-150"></i>
            </button>
          </div>

      </div>
      <hr>
      <div class="row">
          <div class="col-12">
              <table class="table text-dark-m2 text-95 table-bordered table-hover table-striped table-responsive" id="table">
                  <thead class="bgc-white text-grey text-uppercase text-80">
                    <tr>
                      <th>N°</th>
                      <th>Logo</th>
                      <th>Equipo</th>
                      <th>Foto</th>
                      <th>Jugador</th>
                      <th>Marcador</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let goleador of goleadores; let i=index;">
                      <tr>
                        <td>
                          {{(i+1)}}
                        </td>
                        <td>
                          <img width="50" height="50" alt="sin imagen" src="{{rest_server+goleador.logo_equipo}}" />
                        </td>
                        <td>
                          {{goleador.equipo}}
                        </td>
                        <td>
                          <img width="50" height="50" alt="sin imagen" src="{{rest_server+goleador.foto_jugador}}" />
                        </td>
                        <td >
                          {{goleador.jugador}}
                        </td>
                        <td >
                          {{goleador.marcador}}
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
          </div>
      </div>
  </div>
</ng-template>

<!-- Cierres de caja de las mesas del rol: solo informativo. Los cobros, egresos y saldos los registra la mesa (caja mesa
     web o tablet); al procesar se vuelve a leer el cierre guardado, asi que aqui solo se elige el movimiento y la caja. -->
<ng-template #modal_registro_caja let-modal>
    <div class="modal-header card-header">
        <div class="col-10">
            <span class="text-blue text-125">Cierre de Caja</span>
            <span *ngIf="cierres_mesas.length>0" class="text-grey text-90 ml-1">{{cierres_mesas.length}} cierre(s) de mesa</span>
        </div>
        <div class="col-2 text-right">
            <button type="button" class="btn btn-danger" (click)="modal.dismiss('Cross click')">
              <i class="fa fa-times red2 text-110"></i>
            </button>
        </div>
    </div>
    <div class="modal-body card-body">
      <div *ngIf="cierres_mesas.length==0" class="text-center text-grey-d1 py-4">Las mesas todavía no guardaron cierres de caja para este rol.</div>

      <!-- un cierre por mesa y fecha -->
      <div *ngIf="cierres_mesas.length>0" class="d-flex flex-nowrap overflow-auto pb-2 mb-2 border-b-1 brc-grey-l3">
        <button *ngFor="let cierre_mesa of cierres_mesas; let ic=index;" type="button" class="btn btn-sm mr-1 text-nowrap"
          [ngClass]="ic==indice_cierre_seleccionado?'btn-primary':'btn-outline-primary'" (click)="indice_cierre_seleccionado=ic">
          <i class="fa fa-user mr-1"></i>{{cierre_mesa.mesa?.persona?.nombre_completo}}
          <span class="badge badge-light ml-1">{{cierre_mesa.fecha_texto}}</span>
          <i class="fas ml-1" [ngClass]="cierre_mesa.procesado?'fa-check-circle text-success-m1':'fa-hourglass-half text-warning-m1'" [title]="cierre_mesa.procesado?'Procesada':'Por procesar'"></i>
        </button>
      </div>

      <ng-container *ngIf="cierres_mesas[indice_cierre_seleccionado] as cierre_mesa">
        <!-- resumen -->
        <div class="row mx-n1 mb-2">
          <div class="col-6 col-md-3 px-1 mb-2">
            <div class="radius-1 p-2 bgc-green-l4 h-100">
              <div class="text-grey-d1 text-85">Efectivo</div>
              <div class="font-bolder text-120 text-success-d2">Bs {{(cierre_mesa.total_ingresos_efectivo || 0) | number:'1.2-2'}}</div>
            </div>
          </div>
          <div class="col-6 col-md-3 px-1 mb-2">
            <div class="radius-1 p-2 bgc-blue-l4 h-100">
              <div class="text-grey-d1 text-85">QR</div>
              <div class="font-bolder text-120 text-blue-d2">Bs {{(cierre_mesa.total_ingresos_qr || 0) | number:'1.2-2'}}</div>
            </div>
          </div>
          <div class="col-6 col-md-3 px-1 mb-2">
            <div class="radius-1 p-2 bgc-red-l4 h-100">
              <div class="text-grey-d1 text-85">Egresos</div>
              <div class="font-bolder text-120 text-danger-d1">Bs {{(cierre_mesa.total_egresos || 0) | number:'1.2-2'}}</div>
            </div>
          </div>
          <div class="col-6 col-md-3 px-1 mb-2">
            <div class="radius-1 p-2 h-100 text-white" [ngClass]="cierre_mesa.saldo_caja>0?'bgc-success':'bgc-danger'">
              <div class="text-85">Saldo final caja</div>
              <div class="font-bolder text-120">Bs {{(cierre_mesa.saldo_caja || 0) | number:'1.2-2'}}</div>
            </div>
          </div>
        </div>

        <!-- procesar: crea las ventas, pagos y compras del cierre -->
        <div *ngIf="cierre_mesa.procesado" class="alert bgc-green-l4 brc-green-m3 text-success-d2 py-2 mb-3">
          <i class="fas fa-check-circle mr-1"></i>Esta caja ya fue procesada.
        </div>
        <div *ngIf="!cierre_mesa.procesado" class="radius-1 bgc-purple-l5 border-1 brc-purple-l2 p-2 mb-3">
          <div class="row mx-n1 align-items-end">
            <div class="col-12 col-md-5 px-1 mb-2 mb-md-0">
              <label class="text-grey-d1 text-90 mb-1">Movimiento</label>
              <select [compareWith]="compararObjectos" name="movimiento" class="form-control" [(ngModel)]="cierre_rol.movimiento">
                <option [ngValue]="null">Seleccionar</option>
                <option [ngValue]="transaccion" *ngFor="let transaccion of movimientos"><ng-container *ngIf="transaccion.nombre_corto==gloval_variable.Dictionary.EGRE_PROFORMA">{{obtenerTextoEmpresa(gloval_variable.Dictionary.TEXTO_RECIBO_NOTA_VENTA)}}</ng-container><ng-container *ngIf="transaccion.nombre_corto!=gloval_variable.Dictionary.EGRE_PROFORMA">{{transaccion.nombre}}</ng-container></option>
              </select>
            </div>
            <div class="col-12 col-md-4 px-1 mb-2 mb-md-0">
              <label class="text-grey-d1 text-90 mb-1">Caja</label>
              <select [compareWith]="compararObjectos" name="caja" class="form-control" [(ngModel)]="cierre_rol.caja">
                <option [ngValue]="null">Seleccionar</option>
                <option [ngValue]="caja" *ngFor="let caja of cajas">{{caja.nombre}}-{{caja.moneda.nombre}}</option>
              </select>
            </div>
            <div class="col-12 col-md-3 px-1">
              <button type="button" class="btn btn-primary btn-block" (click)="procesarCaja(cierre_mesa)">
                <i class="fa fa-cogs mr-1"></i>Procesar caja
              </button>
            </div>
          </div>
        </div>

        <!-- cobros de cada partido, tal como los registro la mesa -->
        <div class="text-grey-d1 text-uppercase text-80 mb-1">Cobros por partido</div>
        <div *ngIf="!cierre_mesa.partidos || cierre_mesa.partidos.length==0" class="text-grey-d1 text-90 mb-3">El cierre no tiene partidos.</div>
        <div *ngFor="let partido of cierre_mesa.partidos" class="card border-1 brc-grey-l3 radius-1 mb-2">
          <div class="card-header bgc-grey-l4 py-1 px-2 d-flex justify-content-between align-items-center">
            <span class="text-dark-m2 text-95 font-bolder">
              {{partido.equipo_1?.nombre}}
              <span class="badge badge-primary mx-1">{{partido.marcador_equipo_1 ?? '-'}} : {{partido.marcador_equipo_2 ?? '-'}}</span>
              {{partido.equipo_2?.nombre}}
            </span>
            <span class="text-grey text-85 text-nowrap ml-2">{{partido.fecha_hora | date:'dd/MM HH:mm'}}</span>
          </div>
          <div class="card-body p-0">
            <div class="row mx-0">
              <div *ngFor="let equipo of [partido.equipo_1,partido.equipo_2]; let ie=index;" class="col-12 col-md-6 px-2 py-1" [ngClass]="{'border-l-1 brc-grey-l3':ie==1}">
                <div class="d-flex justify-content-between text-90 font-bolder text-primary-d1">
                  <span class="text-truncate">{{equipo?.nombre}}</span>
                  <span *ngIf="(ie==0?partido.w_o_equipo_1:partido.w_o_equipo_2)?.es_wo" class="badge badge-danger ml-1">W.O.</span>
                </div>
                <div *ngIf="!equipo?.detalle_pago || equipo.detalle_pago.length==0" class="text-grey text-85 py-1">Sin cobros.</div>
                <div *ngFor="let detalle_pago of equipo?.detalle_pago" class="d-flex justify-content-between border-b-1 brc-grey-l4 py-1 text-85">
                  <div class="pr-2" style="min-width: 0;">
                    <div class="text-dark-m2">{{detalle_pago.producto?.nombre}}</div>
                    <div *ngIf="detalle_pago.descripcion" class="text-grey">{{detalle_pago.descripcion}}</div>
                    <span *ngIf="detalle_pago.es_pendiente" class="badge badge-sm bgc-blue-l3 text-dark-m2">Pago de deuda anterior</span>
                  </div>
                  <div class="text-right text-nowrap">
                    <div *ngIf="detalle_pago.importe>0" class="text-success-d2">Ef. {{detalle_pago.importe | number:'1.2-2'}}</div>
                    <div *ngIf="detalle_pago.qr>0" class="text-blue-d2">QR {{detalle_pago.qr | number:'1.2-2'}}</div>
                    <div *ngIf="obtenerCreditoDetallePago(detalle_pago)>0" class="text-danger-d1">Crédito {{obtenerCreditoDetallePago(detalle_pago) | number:'1.2-2'}}</div>
                  </div>
                </div>
                <div *ngIf="equipo?.detalle_pago?.length>0" class="d-flex justify-content-between text-85 font-bolder pt-1">
                  <span>Total</span>
                  <span class="text-nowrap">
                    <span class="text-success-d2">Ef. {{obtenerTotalesEquipoCierre(equipo).efectivo | number:'1.2-2'}}</span>
                    <span class="text-blue-d2 ml-2">QR {{obtenerTotalesEquipoCierre(equipo).qr | number:'1.2-2'}}</span>
                    <span *ngIf="obtenerTotalesEquipoCierre(equipo).credito>0" class="text-danger-d1 ml-2">Créd. {{obtenerTotalesEquipoCierre(equipo).credito | number:'1.2-2'}}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- egresos y ajustes registrados por la mesa -->
        <div class="text-grey-d1 text-uppercase text-80 mt-3 mb-1">Egresos y ajustes</div>
        <div class="row mx-n1 text-90">
          <div class="col-6 col-md-4 px-1 d-flex justify-content-between border-b-1 brc-grey-l4 py-1"><span>Pago árbitro</span><span>Bs {{(cierre_mesa.pago_arbitro || 0) | number:'1.2-2'}}</span></div>
          <div class="col-6 col-md-4 px-1 d-flex justify-content-between border-b-1 brc-grey-l4 py-1"><span>Pago mesa</span><span>Bs {{(cierre_mesa.pago_mesa || 0) | number:'1.2-2'}}</span></div>
          <div class="col-6 col-md-4 px-1 d-flex justify-content-between border-b-1 brc-grey-l4 py-1"><span>Pago otros</span><span>Bs {{(cierre_mesa.pago_otros || 0) | number:'1.2-2'}}</span></div>
          <div class="col-6 col-md-4 px-1 d-flex justify-content-between border-b-1 brc-grey-l4 py-1"><span>Saldo faltante</span><span class="text-danger-d1">Bs {{(cierre_mesa.saldo_faltante || 0) | number:'1.2-2'}}</span></div>
          <div class="col-6 col-md-4 px-1 d-flex justify-content-between border-b-1 brc-grey-l4 py-1"><span>Saldo sobrante</span><span class="text-success-d2">Bs {{(cierre_mesa.saldo_sobrante || 0) | number:'1.2-2'}}</span></div>
        </div>
      </ng-container>
    </div>
</ng-template>

<ng-template #modal_registro_rol_partido_fixture let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Gestión de Canchas</h4>
        <button *ngIf="aplicacion.puede_crear" (click)="guardarRolesPartidos()" class="btn btn-primary"  >
            <i class="fa fa-save text-110 mr-1"></i>
        </button>&nbsp;
        <button type="button" class="btn btn-primary btn-danger" (click)="modal.dismiss('Cross click')" >
              <i class="fa fa-times red2 align-top bigger-125"></i>
        </button>
    </div>

    <!-- Referenciamos el cuerpo para el boundary -->
    <div class="modal-body" #modalBody style="background: #f8f9fa;">
        
        <div class="contenedor-canchas" cdkDropListGroup>
            <div class="cancha-col" *ngFor="let cancha of roles_partido_seleccionados">
                <h5 class="text-center">{{ cancha.rol.nombre }}</h5>
                
                <div style="background: white; border: 1px solid #ccc; width: 100%; display: block; position: relative;"
                    cdkDropList
                    [cdkDropListData]="cancha.partidos"
                    (cdkDropListDropped)="drop($event)"
                    class="lista-partidos-scroll">
                    
                    <div class="partido-card"  cdkDragHandle
                         *ngFor="let partido of cancha.partidos" 
                         cdkDrag
                         [cdkDragBoundary]="modalBody"> <!-- Evita que el item salga del modal -->
                         
                        <div class="info-partido d-flex align-items-center justify-content-between w-100">
    
                          <!-- Equipo A -->
                          <div class="equipo-container d-flex align-items-center">
                            <img [src]="rest_server+partido.equipo_1.logo" class="escudo-equipo mr-2" alt="Logo A">
                            <span class="nombre-equipo">{{ partido.equipo_1.nombre }}</span>
                          </div>

                          <!-- Centro: Horario y VS -->
                          <div class="centro-partido text-center">
                            <div class="horario-badge">{{ partido.fecha_hora | date:'dd/MM/yyyy HH:mm' }}</div>
                            <div class="badge badge-sm badge-success">{{ partido.categoria.nombre}}</div>
                            <small class="text-muted">VS</small>
                          </div>

                          <!-- Equipo B -->
                          <div class="equipo-container d-flex align-items-center flex-row-reverse">
                            <img [src]="rest_server+partido.equipo_2.logo" class="escudo-equipo ml-2" alt="Logo B">
                            <span class="nombre-equipo">{{ partido.equipo_2.nombre }}</span>
                          </div>

                        </div>

                        <!-- Opcional: Un icono para indicar que es arrastrable -->
                        <div class="drag-handle" cdkDragHandle>
                            <i class="fa fa-grip-vertical"></i>
                        </div>
                    </div>

                    <div class="empty-placeholder" *ngIf="cancha.partidos.length === 0">
                        Sin partidos
                    </div>
                </div>
            </div>
        </div>

    </div>
</ng-template>